// extracted by mini-css-extract-plugin
module.exports = {"img_ontainer":"PreviewUploadImg_img_ontainer__1_I-I","img_wrapper":"PreviewUploadImg_img_wrapper__1vPNe","close_icon":"PreviewUploadImg_close_icon__3L-nR"};